import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';

@withText(props => ({
    newsNumber: <Text id='input.newsNumber-help'>newsNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewNews extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('news'),
            sectionsUserOnly: fields.get('news', ['News simple']),
        };
    }

    loadAll = async (props = this.props, emptyFirst = true) => {
        const { id, tag, raceId, conventionId, userOnly } = props;
        // console.log('loadAll', { id })
        const { newsStore } = this.props.stores;
        if (emptyFirst) {
            newsStore.updateKeyValue('news', {});
        }
        if (id) {
            await newsStore.load(id, false, { addData: ['races', 'tags', 'creators', 'likes', 'comments'], query: { all: 1 } });
        } else {
            newsStore.updateObjectKeyValue('newNews', 'tag', tag);
            if (raceId) {
                newsStore.updateObjectKeyValue('newNews', 'race', raceId);
            }
            if (conventionId) {
                newsStore.updateObjectKeyValue('newNews', 'convention', conventionId);
            }
            if (userOnly) {
                newsStore.updateObjectKeyValue('newNews', 'active', 1);
            }
        }
    }

    createNews = async () => {
        const { callback = () => {}, id, isNew } = this.props;
        const { newsStore, appState } = this.props.stores;
        const { newNews } = newsStore;

        if (isNew) {
            const response = await newsStore.insert({
                ...newNews,
                hostname: newsStore.currentHostname,
            });
            newsStore.updateKeyValue('news', response?.data?.news);
            newsStore.updateKeyValue('newNews', {});
            callback();
            appState.toggleDrawer();
        }
    }

    chooseItem = (e) => {
        const { id } = e.target.closest('.similar-item').dataset;
        const { newsStore } = this.props.stores;
        const { foundList } = newsStore;
        const item = foundList.find((item) => item.id === parseInt(id, 10));
        newsStore.updateKeyValue('newNews', {
            ...item,
        });
        newsStore.resetSearch();
    }

    toggleSimilar = () => {
        const { showSimilar } = this.state;
        this.setState({
            showSimilar: !showSimilar,
        });
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { week, isNew, drawerLevel, installation, lookupArray = 'newsList', userOnly } = this.props;
        const { sections, sectionsUserOnly, showSimilar } = this.state;
        const { userStore, newsStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newNews, foundList, foundListKeys } = newsStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const activeSections = (userOnly && isNew) ? sectionsUserOnly : sections;

        return (<>
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(installation, null, 4)}</xmp> */}
                    {userOnly ? <></> : <>
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='news.new'>New news</Text> : <Text id='news.edit'>Edit news</Text>}
                        {installation?.id && <>
                            <span class='ms-2'>
                                :: {installation.name}
                            </span>
                        </>}
                    </div>
                    </>}

                    {showSimilar && foundList?.length > 0 && <>
                        <div class='w-100 d-flex flex-column justify-content-start'>
                            <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                                <div class='mx-4 font-weight-lighter px-3 py-1 text-muted' >
                                    <small class='text-uppercase'>
                                        <Text id='news.similar'>Similar newss</Text>
                                    </small>
                                </div>
                                <div class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} mx-4 d-flex flex-column px-0 overflow-auto`} style='font-size: 1.1em; border-radius: 10px; max-height: 35vh;'>
                                    {foundList.map((item, idx) => {
                                        return(<>
                                            <div class='d-flex flex-row justify-content-between align-items-center'>
                                                <div
                                                    class='flex-fill similar-item py-2 px-3'
                                                    data-id={item.id}
                                                    onClick={this.chooseItem}
                                                >
                                                    {item.name}
                                                    <span class='font-weight-lighter text-muted ms-3'>{item.newsNumber}</span>
                                                </div>
                                                {/* {item.images[0] && <>
                                                    <div>
                                                        <div class=''>
                                                            <img src={`${item.images[0].s3MediumLink}`} class='rounded-lg img-fluid' style='max-height: 45px;' />
                                                        </div>
                                                    </div>
                                                </>} */}
                                            </div>
                                        </>);
                                    })}
                                </div>
                            </div>
                        </div>
                    </>}

                    <div class='w-100 d-flex flex-column justify-content-start'>
                        <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={activeSections}
                                holdingStore={newsStore}
                                objectName={isNew ? 'newNews' : 'news'}
                                isNew={isNew}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                                lookupArray={lookupArray}
                                rightHeader={isNew && foundList?.length > 0 ? <span class='text-success font-weight-bold'><i class='fa-solid fa-circle-info' /> Similar newss ({foundList.length})</span> : null}
                                rightHeaderClick={this.toggleSimilar}
                            />
                        </div>
                    </div>
                </div>



            </div>

            {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                <button type='button' class='btn btn-primary rounded-pill' onClick={this.createNews}>
                    {isNew ? <Text id='news.create'>Create news</Text> : <Text id='news.save'>Save news</Text>}
                </button>
            </div>}
        </>);
    }
}

export default NewNews;
